<template>
  <v-app light>
    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list class="pt-0" dense>
        <template v-for="item in items">
          <v-list-tile :key="item.title" v-if="!item.children" :to="{name: item.link}">
            <v-list-tile-title class="primary--text">{{item.title}}</v-list-tile-title>
          </v-list-tile>

          <v-list-group :key="item.title" v-if="item.children">
            <v-list-tile slot="activator">
              <v-list-tile-title class="primary--text">{{item.title}}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile :to="{name: child.link}" v-for="child in item.children" :key="child.title">
              <v-list-tile-title class="primary--text">{{child.title}}</v-list-tile-title>
            </v-list-tile>
          </v-list-group>
        </template>
      </v-list>

      <v-list v-if="user">
        <v-divider class="mt-3 mb-0"></v-divider>
        <v-list-group no-action>
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title class="primary--text">Beheer</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{name: 'logout'}">
            <v-list-tile-content>
              <v-list-tile-title class="primary--text">Uitloggen</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar class="white primary--text">
      <v-toolbar-side-icon class="hidden-sm-and-up" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="title font-weight-light text-uppercase">
        <router-link :to="{name:'home'}">
          {{title}}
          <!-- <v-img :src="logoAsset" contain width="70" class="mt-1" alt="logo"></v-img> -->
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-xs-only">
        <template v-for="item in items">
          <v-btn
            v-if="!item.children"
            class="primary--text"
            :to="{name: item.link}"
            flat
            :key="item.title"
          >{{item.title}}</v-btn>
          <v-menu :key="item.title" offset-y v-if="item.children">
            <v-btn slot="activator" flat class="primary--text">{{item.title}}</v-btn>
            <v-list class="py-0">
              <v-list-tile
                :to="{name: child.link}"
                v-for="child in item.children"
                :key="child.title"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{child.title}}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
        </template>

        <v-divider class="mx-3" inset vertical v-if="user"></v-divider>
        <v-menu offset-y v-if="user">
          <v-btn slot="activator" flat class="primary--text">Beheer</v-btn>
          <v-list class="py-0">
            <v-list-tile :to="{name: 'logout'}">
              <v-list-tile-content>
                <v-list-tile-title>Uitloggen</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>

    <v-content class="sv-content" v-if="fields">
      <router-view/>
    </v-content>
    <v-layout v-else align-center justify-center row fill-height>
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-layout>

    <v-footer class="primary darken-1" absolute bottom>
      <v-layout row wrap>
        <v-flex xs8>
          <div class="white--text ml-3 text-truncate">
            <v-icon class="white--text mr-1 body-1" style="vertical-align: middle">fas fa-copyright</v-icon>
            <span class="caption">{{copyright}}</span>
          </div>
        </v-flex>
        <v-flex xs4 class="pr-3">
          <v-layout justify-end>
            <a href="https://www.ngsmassage.nl/" target="_blank" class="footer-img">
              <v-img contain :src="ngsLogoAsset" height="25" max-width="100"></v-img>
            </a>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import firebase from "firebase";

export default {
  name: "App",
  data() {
    return {
      drawer: false,
      title: "SANA VITA SPORTMASSAGE",
      kvk: "KvK 57323755",
      items: [
        {
          title: "Home",
          link: "home"
        },
        {
          title: "Diensten",
          children: [
            {
              title: "Sportmassage",
              link: "sportmassage"
            },
            {
              title: "Ontspanningsmassage",
              link: "ontspanningsmassage"
            },

            {
              title: "Medical taping",
              link: "medicaltaping"
            }
          ]
        },
        {
          title: "Tarieven",
          link: "tarieven"
        },
        {
          title: "Over mij",
          link: "overmij"
        },
        {
          title: "Nieuws",
          link: "nieuws"
        },
        {
          title: "Contact",
          link: "contact"
        }
      ]
    };
  },
  computed: {
    logoAsset() {
      return require("@/assets/sv/logo/logo_small.png");
    },
    ngsLogoAsset() {
      return require("@/assets/sv/ngs-logo.png");
    },
    copyright() {
      return `${new Date().getFullYear()} ${this.title} - ${this.kvk}`;
    },
    user() {
      return this.$store.getters.user;
    },
    fields() {
      return this.$store.getters.fields;
    }
  },
  created() {
    // auto sign in
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.$store.commit("setUser", user);
      }
    });

    // auto fetch fields
    this.$store.dispatch("getFields");
  }
};
</script>

<style lang="scss">
.v-btn {
  border-radius: 8px;
}
nav .v-btn {
  border-radius: 0;
}
.image-title {
  text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}
a {
  text-decoration: none;
}
.sv-content {
  margin-bottom: 36px;
}

.fullwidth {
  width: 100%;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>

<style lang="scss" scoped>
.footer-img {
  display: block;
  width: 100px;
}
</style>


